import React, {useMemo, memo} from 'react';
import {Props} from './ac-definition-list.proptypes';
import clsx from 'clsx';

// Imports => Utils
import {AcUUID, AcIsObject} from '@asdf-utils';

const _CLASSES = {
  MAIN: 'ac-definition-list',
  WRP: 'ac-definition-list-wrp',
  ITEM: 'ac-definition-list__item',
};

const AcDefinitionList = memo(({items = [], className, ...rest}) => {
  const getItemClassNames = useMemo(() => {
    return clsx(_CLASSES.ITEM);
  }, []);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN);
  }, []);

  const getWrpClassNames = useMemo(() => {
    return clsx(_CLASSES.WRP, className);
  }, [className]);

  const format = val => {
    if (AcIsObject(val)) {
      return val;
    } else {
      return (
        <span
          dangerouslySetInnerHTML={{
            __html: val,
          }}
        />
      );
    }

    return val;
  };

  const renderListItems = useMemo(() => {
    if (!items) return null;

    const collection = items;
    const len = collection.length;
    let n = 0;
    let result = [];

    for (n; n < len; n++) {
      const item = collection[n];
      const {label, value} = item;

      const object = (
        <React.Fragment key={AcUUID()}>
          <dt key={AcUUID()} className={getItemClassNames}>
            {format(label)}
          </dt>
          <dd key={AcUUID()} className={getItemClassNames}>
            {format(value)}
          </dd>
        </React.Fragment>
      );

      result.push(object);
    }

    return result;
  }, [items]);

  return (
    <div className={getWrpClassNames} {...rest}>
      <dl className={getMainClassNames}>{renderListItems}</dl>
    </div>
  );
});

AcDefinitionList.displayName = 'AcDefinitionList';
AcDefinitionList.propTypes = Props;

export {AcDefinitionList};
export default AcDefinitionList;
